// extracted by mini-css-extract-plugin
export default {"layout":"ServicePageLayout_layout__CpSkM","main":"ServicePageLayout_main__HqOzv"};